import React, { useEffect, useRef } from 'react';
import { Alert, AlertDescription, AlertTitle } from '@si-armes/dsfr-react';
import * as PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const AlerteAutoClosed = ({ titre, dateCreation, type, description, onClose }) => {
    const role = type === 'error' || type === 'warning' ? 'alert' : 'status';

    const location = useLocation();
    const previousPathRef = useRef(location.pathname);

    useEffect(() => {
        if (location.pathname !== previousPathRef.current) {
            previousPathRef.current = location.pathname;
            if (dateCreation < new Date(Date.now() - 10000)) {
                onClose();
            }
        }
    }, [location.pathname, onClose]);
    return (
        <Alert severity={type} role={role} size="md" onClose={onClose}>
            <AlertTitle>{titre}</AlertTitle>
            <AlertDescription>{description}</AlertDescription>
        </Alert>
    );
};

AlerteAutoClosed.propTypes = {
    titre: PropTypes.string,
    dateCreation: PropTypes.object,
    type: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AlerteAutoClosed;
